export default __webpack_public_path__ + "61ac88210f74789196724ba8d916fdf2.png";